import { useQuery } from '@tanstack/react-query'
import { ruleLabelsApi } from '@/api/ruleLabelsApi'

export const memoryRuleLabelsQueryKey = ['memory-rule-labels'] as const

export function useRuleLabels(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: memoryRuleLabelsQueryKey,
    queryFn: () => ruleLabelsApi.list(),
    staleTime: 1000 * 60 * 60,
    enabled: options.enabled ?? true,
  })
}
